import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

export interface IPatientInteractionDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  patientRef: ISerialisedDocumentReference;
  title: string;
  type: string;
  pinned: boolean;
  tags: IBigQueryNamedDocument[];
  owner?: IBigQueryNamedDocument;
  action?: string;
  content: string;
}
